import { BrandThemeSync } from '@shared/branding/BrandThemeSync';
import { applyBranding } from '@shared/branding/config';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import { router } from '@app/routes';
import { queryClient } from '@shared/lib/react-query';
import { queryPersistOptions } from '@shared/lib/react-query-persist';
import { ErrorBoundary } from '@shared/lib/monitoring';
import { log } from '@shared/lib/logger';
import { ThemeProvider } from '@app/providers';
import { Toaster } from '@shared/ui/sonner';
import { AppI18nProvider } from '@shared/i18n';
import { disableExternalPageTranslation } from '@shared/lib/browser-translation';
import { WebViewNativeRuntime } from '@shared/components/WebViewNativeRuntime';
import { setupQueryOnlineManager } from '@shared/lib/network-status';

applyBranding();
disableExternalPageTranslation();
setupQueryOnlineManager();

// Log application startup
log.info('Workspace Frontend starting', {
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  environment: import.meta.env.VITE_NODE_ENV || import.meta.env.MODE,
  timestamp: new Date().toISOString(),
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <AppI18nProvider>
      <ThemeProvider attribute='class' defaultTheme='system' enableSystem>
        <ErrorBoundary>
          <PersistQueryClientProvider client={queryClient} persistOptions={queryPersistOptions}>
            <BrandThemeSync />
            <WebViewNativeRuntime />
            <RouterProvider router={router} />
            <Toaster />
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
          </PersistQueryClientProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </AppI18nProvider>
  </StrictMode>
);
